import { useContext } from 'react';
import { AdminToolsContext } from '../Context/AdminTools/index.js';

const useAdminTools = () => {
  const context = useContext(AdminToolsContext);

  if (!context) {
    throw new Error('useAdminTools must be within a AdminToolsContextProvider');
  }

  return context;
};

export default useAdminTools;

